import { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

//
import ReportInfoCard from '../OverAll/components/ReportInfoCard';
import EventsReportTable from './Components/EventsReportTable';
import DownloadBtn from '../../../../Components/Buttons/DownloadBtn';

//
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';

//
import { BsFillCalendarCheckFill, BsFillCalendarFill } from 'react-icons/bs';

/**
 *
 */
function EventsReport() {
  const [eventsData, setEventsData] = useState([]);
  const [eventsDataStats, setEventsDataStats] = useState({});
  const [loading, setLoading] = useState([]);

  useEffect(() => {
    const getEventsData = async () => {
      try {
        setLoading(true);
        const response = await fetchWrapper.get('/report/events-list/?type=data');
        let { data, stats } = response.data;
        setEventsDataStats(stats);
        setEventsData(data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        ErrorMessageHandler(err);
      }
    };
    getEventsData();
  }, []);
  return (
    <div>
      <Row className="my-3">
        <Col md="2">
          <ReportInfoCard
            titleId={'ongoingEvents'}
            count={eventsDataStats.total_ongoing_events}
            Icon={BsFillCalendarCheckFill}
            iconColor="#dc3545"
          />
        </Col>
        <Col md="2">
          <ReportInfoCard
            titleId={'upcomingEvents'}
            count={eventsDataStats.total_upcoming_events}
            Icon={BsFillCalendarFill}
            iconColor="#1aa2b8"
          />
        </Col>
        <Col md="2">
          <ReportInfoCard
            titleId={'completedEvents'}
            count={eventsDataStats.total_completed_events}
            Icon={BsFillCalendarFill}
            iconColor="#dc3545"
          />
        </Col>
      </Row>
      <Row className="mb-2">
        <div className="d-flex justify-content-end align-items-center">
          <DownloadBtn apiUrl={`/report/events-list/?type=excel`} type="excel" />
          <DownloadBtn apiUrl={`/report/events-list/?type=pdf`} type="pdf" />
        </div>
      </Row>
      <Row>
        <EventsReportTable eventsData={eventsData} loading={loading} />
      </Row>
    </div>
  );
}

export default EventsReport;
